import React from 'react';

import { Box, Text, xcss } from '@atlaskit/primitives';

const HelperMessageStyles = xcss({
	color: 'color.text.subtlest',
	textAlign: 'start',
});

export const HelperMessage = ({ children }: React.PropsWithChildren<{}>) => (
	<Box paddingBlockStart="space.025" xcss={HelperMessageStyles}>
		<Text size="small">{children}</Text>
	</Box>
);
